// filepath: src/pages/matrimony/components/sectionForms/FamilyEditForm.tsx
import React from "react";
import {
  FormControl,
  FormLabel,
  HStack,
  Input,
  Select,
} from "@chakra-ui/react";
import { commonInputProps, commonSelectProps } from "src/pages/matrimony/pages/matrimonyForm.ui";
import { FIELD_LABELS } from "src/utils/matrimonyFieldLabels";
import { FAMILY_STATUS_OPTIONS, FAMILY_TYPE_OPTIONS } from "src/utils/matrimonyOptions";
import type { FamilyState } from "src/types/marriageProfileSectionEdit.types";
import type { BaseSectionFormProps } from "./sectionFormProps";

type Props = BaseSectionFormProps & { values: FamilyState };

const FamilyEditForm: React.FC<Props> = ({ values, errors: _errors, setField }) => (
  <>
    <FormControl>
      <FormLabel>{FIELD_LABELS.FATHER_NAME}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.fatherName || ""}
        onChange={(e) => setField("fatherName", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.MOTHER_NAME}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.motherName || ""}
        onChange={(e) => setField("motherName", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.FATHER_OCCUPATION}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.fatherOccupation || ""}
        onChange={(e) => setField("fatherOccupation", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.MOTHER_OCCUPATION}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.motherOccupation || ""}
        onChange={(e) => setField("motherOccupation", e.target.value)}
      />
    </FormControl>

    <HStack spacing={3} align="start">
      <FormControl>
        <FormLabel>{FIELD_LABELS.FAMILY_TYPE}</FormLabel>
        <Select
          {...commonSelectProps}
          value={values.familyType || ""}
          onChange={(e) => setField("familyType", e.target.value)}
          placeholder="Select family type"
        >
          {FAMILY_TYPE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </Select>
      </FormControl>

      <FormControl>
        <FormLabel>{FIELD_LABELS.FAMILY_STATUS}</FormLabel>
        <Select
          {...commonSelectProps}
          value={values.familyStatus || ""}
          onChange={(e) => setField("familyStatus", e.target.value)}
          placeholder="Select status"
        >
          {FAMILY_STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </Select>
      </FormControl>
    </HStack>

    <FormControl>
      <FormLabel>{FIELD_LABELS.NATIVE_PLACE}</FormLabel>
      <Input
        {...commonInputProps}
        value={values.nativePlace || ""}
        onChange={(e) => setField("nativePlace", e.target.value)}
      />
    </FormControl>

    <FormControl>
      <FormLabel>{FIELD_LABELS.TOTAL_FAMILY_MEMBERS}</FormLabel>
      <Input
        {...commonInputProps}
        type="number"
        value={values.totalFamilyMembers || ""}
        onChange={(e) => setField("totalFamilyMembers", e.target.value)}
        placeholder="e.g. 5"
      />
    </FormControl>
  </>
);

export default FamilyEditForm;
